import mapResponseToPriceConfiguration from './mappers/mapResponseToPriceConfiguration'
import { IKidTax } from './index'

export default function(api: GlobalFetch) {
  return async function(objectId: string, calendarId: string) {
    const response = await api.fetch(
      `/api/v2/price/settings/id_calendar/${calendarId}/id_object/${objectId}/`,
    )
    const responseBody: IData = await response.json()

    return mapResponseToPriceConfiguration(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

export interface IItemData {
  id_object: number
  short_stay_price: number
  long_stay_price: number
  weekend_price: number
  displayed: string
  kids_price: number
  kids: IKid[]
  switch_status: string
  kids_taxes: IKidTax[]
  price_per_person: number
  restrictions: number
  restriction_min_stay: number
  restriction_min_stay_thru: number
  localtax_days: string
  restriction_max_stay: number
  restriction_max_stay_thru: number
  restriction_exact_stay: number
  restriction_close_at_arrival: number
  restriction_close_at_departure: number
  restriction_min_before_arrival: number
  restriction_max_before_arrival: number
  food: number
  food_bb: string
  food_bb_included: number
  food_hb: string
  food_hb_included: number
  food_fb: string
  food_fb_included: number
  integrations: {
    booking: {
      active: number
      percent: number
      rates?: Record<string, number>
      ratesNames?: Record<string, string>
    }
    airbnb: {
      active: number
      percent: number
    }
  }
  localtax: number
  localtax_adults: string
  localtax_kids: string
  localtax_included: number
  currency: string
  default: number
}

interface IKid {
  id: number
  age_from: number
  age_to: number
  food_discount: number
}
